export type InWishlist<T> = T & {
  addedToWishlist?: boolean;
};

// export class Prod {
//   ProductID?: string;
//   Mileage?: string;
//   Name?: string;
//   ProductManAndTitle?: string;
//   NameEsp?: string;
//   imageName?: string;
//   qty?: number;
//   subtotal?: number;
//   // clientRedemptionOrderItemId: string;
//   redemptionOrderItemCashAmount?: string;
// }
